import { API } from 'aws-amplify';

const API_NAME = 'admin-api-v2';

export const getCurrentTOS = async () => {
  return API.get(API_NAME, '/tos/current', {});
};

export const updateTOS = async (data) => {
  return API.post(API_NAME, '/tos/update', { body: data });
};

export const listVersions = async () => {
  return API.get(API_NAME, '/tos/versions', {});
};
